<template>
  <div class="family-dropdown-container">
    <button class="toggle-button" @click="isOpen = !isOpen">
      Family Site
      <b-icon v-if="!isOpen" icon="chevron-down" class="arrow" />
      <b-icon v-else icon="chevron-up" class="arrow" />
    </button>

    <div v-if="isOpen" class="dropdown-grid">
      <a
        v-for="(site, index) in familySites"
        :key="index"
        :class="['dropdown-item', site.className]"
        :href="site.href"
        target="_blank"
      >
        {{ lang === 'ENG' && site.name_e ? site.name_e : site.name }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { familySites } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'FamilyDropdown',
  data() {
    return {
      isOpen: false,
      familySites: familySites
    };
  },
  computed: {
    ...mapState('report_list', ['lang'])
  }
};
</script>

<style scoped>
.family-dropdown-container {
  position: relative;
  display: inline-block;
}

.toggle-button {
  background: transparent;
  border: 1px solid #000;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 24px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.arrow {
  margin-left: 8px;
  transition: transform 0.2s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

.dropdown-grid {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-top: 4px;
  background: #f6f2f2;
  border: 1px solid #999999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  padding: 8px;
  z-index: 10;
  border-radius: 4px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 2px;
  font-size: 14px;
  text-decoration: none;
  border: 1px solid #999999;
  box-sizing: border-box;
  color: #333;
}

.dropdown-item.skinc-red-bg {
  background-color: #ea002c;
  color: white;
  border-color: #ea002c;
}

.span-2 {
  grid-column: span 2;
}

.dropdown-item:hover {
  background: #ee7501;
  color: white;
  border-color: #ee7501;
}

@media (max-width: 768px) {
  .dropdown-grid {
    top: 100%;
    left: 0;
    right: auto;
    bottom: auto;
    margin-bottom: 0;
    margin-top: 4px;
  }
}
</style>
